const EmailInput = document.getElementById('email-input');
const EmailMobileInput = document.getElementById('email-mobile-input');

const NameInput = document.getElementById('name-input');
const NameMobileInput = document.getElementById('name-mobile-input');

const PasswordInput = document.getElementById('password-input');
const PasswordMobileInput = document.getElementById('password-mobile-input');

const BtnSubmit = document.getElementById('btn-submit');
const BtnMobileSubmit = document.getElementById('btn-mobile-submit');

const inputName = document.querySelector('.name-input');
let buttonsGoogle = document.querySelectorAll('.btn-google');
let validationPass = true;
if (buttonsGoogle.length > 0) {
  buttonsGoogle.forEach((button) => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      document.querySelector('.h_google_button').click();
    });
  });
}

let buttonsFacebook = document.querySelectorAll('.btn-facebook');

if (buttonsFacebook.length > 0) {
  buttonsFacebook.forEach((button) => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      document.querySelector('.h_facebook_button').click();
    });
  });
}

function addEvents() {
  if (inputName) {
    inputName.addEventListener('input', (e) => {
      e.preventDefault();
      let names = e.target.value;
      let spli = names.split(' ');
      switch (spli.length) {
        case 1:
          document.querySelector('.first-name').value = spli[0];
          break;
        case 2:
          document.querySelector('.first-name').value = spli[0];
          document.querySelector('.last-name').value = spli[1];
          break;
        case 3:
          document.querySelector('.first-name').value = `${spli[0]} ${spli[1]}`;
          document.querySelector('.last-name').value = spli[2];
          break;
        case 4:
          document.querySelector('.first-name').value = `${spli[0]} ${spli[1]}`;
          document.querySelector('.last-name').value = `${spli[2]} ${spli[3]}`;
          break;
        default:
          let string = '';
          document.querySelector('.first-name').value = `${spli[0]} ${spli[1]}`;
          spli.forEach((name, index) => {
            if (index > 1) {
              string += name + ' ';
            }
          });
          document.querySelector('.last-name').value = string;
          break;
      }
    });
  }
  EmailInput.addEventListener('keyup', (e) => {
    validateSend();
  });

  EmailMobileInput.addEventListener('keyup', (e) => {
    validateSend();
  });

  NameInput.addEventListener('keyup', (e) => {
    validateSend();
  });

  NameMobileInput.addEventListener('keyup', (e) => {
    validateSend();
  });
  /*  */

  PasswordInput.addEventListener('keyup', (e) => {
    PasswordMobileInput.value = e.target.value;
    validateSend();
    passValidation(e.target.value);
  });

  PasswordInput.addEventListener('focus', (e) => {
    document.getElementById('password-hint').style.display = 'block';
    passValidation(e.target.value);
  });

  PasswordInput.addEventListener('blur', (e) => {
    let val = e.target.value;
    passValidation(val);
    if (!val.length > 0) document.getElementById('password-hint').style.display = 'none';
  });

  PasswordMobileInput.addEventListener('keyup', (e) => {
    PasswordInput.value = e.target.value;
    validateSend();
    passValidation(e.target.value);
  });

  PasswordMobileInput.addEventListener('focus', (e) => {
    document.getElementById('password-mobile-hint').style.display = 'block';
    passValidation(e.target.value);
  });

  PasswordInput.addEventListener('blur', (e) => {
    let val = e.target.value;
    passValidation(val);
    if (!val.length > 0) document.getElementById('password-mobile-hint').style.display = 'none';
  });
}

function validateSend() {
  passValidation(PasswordInput.value);
  if (!EmailInput.value || !emailValidation(EmailInput.value) || !NameInput.value || !validationPass) {
    BtnSubmit.disabled = true;
    BtnSubmit.classList.add('disabled');
  } else {
    BtnSubmit.disabled = false;
    BtnSubmit.classList.remove('disabled');
  }

  if (
    !EmailMobileInput.value ||
    !emailValidation(EmailMobileInput.value) ||
    !NameMobileInput.value ||
    !validationPass
  ) {
    BtnMobileSubmit.disabled = true;
    BtnMobileSubmit.classList.add('disabled');
  } else {
    BtnMobileSubmit.disabled = false;
    BtnMobileSubmit.classList.remove('disabled');
  }
}

function valButtonSend(val) {
  if (val) {
    document.getElementById('password-hint-special').classList.add('checked');
    document.getElementById('password-mobile-hint-special').classList.add('checked');
  } else {
    document.getElementById('password-hint-special').classList.remove('checked');
    document.getElementById('password-mobile-hint-special').classList.remove('checked');
  }
}

function passValidation(val) {
  validation = true;
  if (val.length == 0) {
    validation = false;
  }

  if (val.length < 8) {
    validation = false;
    document.getElementById('password-hint-characters').classList.remove('checked');
    document.getElementById('password-mobile-hint-characters').classList.remove('checked');
  } else {
    document.getElementById('password-hint-characters').classList.add('checked');
    document.getElementById('password-mobile-hint-characters').classList.add('checked');
  }

  if (!passValidNumber(val)) {
    validation = false;
    document.getElementById('password-hint-number').classList.remove('checked');
    document.getElementById('password-mobile-hint-number').classList.remove('checked');
  } else {
    document.getElementById('password-hint-number').classList.add('checked');
    document.getElementById('password-mobile-hint-number').classList.add('checked');
  }

  if (!containsSpecialChars(val)) {
    validation = false;
    document.getElementById('password-hint-special').classList.remove('checked');
    document.getElementById('password-mobile-hint-special').classList.remove('checked');
  } else {
    document.getElementById('password-hint-special').classList.add('checked');
    document.getElementById('password-mobile-hint-special').classList.add('checked');
  }

  if (!validation) {
    validationPass = false;
    valButtonSend(validation);
  } else {
    validationPass = true;
  }

  return val;
}

function emailValidation(val) {
  let regexp =
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return regexp.test(val);
}

function passValidNumber(val) {
  return new RegExp(['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'].join('|')).test(val);
}

function containsSpecialChars(str) {
  const specialChars = `\`!@#$%^&*()_+\/`;

  const result = specialChars.split('').some((specialChar) => {
    if (str.includes(specialChar)) {
      return true;
    }

    return false;
  });

  return result;
}

addEvents();
